import PrivilegeState from 'root/common/thirdParty/privilege/state';
import CHANNEL from 'root/common/thirdParty/const/channel';

/**
 * 特权输出 mixins
 */
export default {
    data() {
        return {
            sourceChannel: '',
        };
    },
    computed: {
        isSourceChannel() {
            return !!this.sourceChannel;
        },
        privilegeClassName() {
            return this.sourceChannelList
                .map(sourceChannel => {
                    return `is-${sourceChannel}`;
                })
                .join(' ');
        },
        // 是否畅由
        isCY() {
            return PrivilegeState.isBelongToChannel(this.sourceChannel, CHANNEL.CHANG_YOU);
        },
        // 是否四川畅由
        isSC_CY() {
            return PrivilegeState.isChannel(this.sourceChannel, CHANNEL.SC_CHANG_YOU);
        },
        channelName() {
            // 畅由要求「骑士」都改为「畅由」
            // 雅居乐没有这个要求
            if (this.isCY) {
                return '畅由';
            }
            return '骑士';
        },
    },
    created() {
        this.sourceChannel = PrivilegeState.get();
        this.sourceChannelList = PrivilegeState.getAll();
    },
    methods: {
        /**
         * 低版本安卓如果 template 是运行时编译的话（在 handlebars 上面写 template），直接写 { [privilegeClassName]: privilegeClassName } 是无法识别的，
         * 所以借助一个方法来生成 :class
         * @param originClass
         * @returns {string|string|*}
         */
        injectPrivilegeClassName(originClass) {
            if (!originClass) {
                return this.privilegeClassName;
            }
            if (typeof originClass === 'string') {
                return `${originClass} ${this.privilegeClassName}`;
            }
            if (typeof originClass === 'object' && this.privilegeClassName) {
                originClass[this.privilegeClassName] = true;
            }
            return originClass;
        },
        /**
         * 讲「全球购骑士卡」/「骑士卡」/「骑士」换成对应的渠道名
         * 目前只有畅由有这个需求
         * @param string
         * @returns {*}
         */
        replaceChannelName(string) {
            return string.replace(/(全球购)?骑士(卡)?/gm, this.channelName);
        },
    },
};
